// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c3e6d37","239":"b52e4e49","732":"0c935630"}[chunkId] + ".chunk.js";
};